import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe} from '@angular/common';
export class ServicesClockOut{
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    console.log("门店信息1001011");
    if(webcontext.ConfigType.toLowerCase()=="form"){
        let request = JSON.parse(webcontext.RequestBody);
        webcontext.OpType = "Edite";
        // let getRow=webcontext.ID.split('&');
        //     request["a_ID"]= getRow[0];
        // request["a_ID"]= webcontext.ID;
        // if(typeof(request["a_EndAddress"])=="undefined" && (typeof(request.a_EndRemark)=="undefined" || request.a_EndRemark.toString().trim()=="")){
        //     webcontext.ResponseMessage.ErrorMessage = "请填写备注说明";
        //     webcontext.ResponseMessage.Success = false;
        // }else if(!request.a_EndAddress &&  (typeof(request.a_EndRemark)=="undefined" || request.a_EndRemark.toString().trim()=="")){
        //   webcontext.ResponseMessage.ErrorMessage = "请填写备注说明";
        //   webcontext.ResponseMessage.Success = false;
        // }
        if(request.a_EndRemark && webcontext.ResponseMessage.Success){//如果填写备注则必须拍摄门头照
          if(typeof(request["a_EndPhoto"])=="undefined"){
            webcontext.ResponseMessage.Success =false;
            webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
          }else if(request.a_EndPhoto.toString().trim() == ""){
            webcontext.ResponseMessage.Success =false;
            webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
          }
        }else if(!request.DeviationNumber){//如果定位成功并且偏差值不存在证明第一次进店，
          if(typeof(request["a_EndPhoto"])=="undefined"){
            webcontext.ResponseMessage.Success =false;
            webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
          }else if(request.a_EndPhoto.toString().trim() == ""){
            webcontext.ResponseMessage.Success =false;
            webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
          }
        }
        if(request.DeviationNumber){//下班门店坐标
          request.a_OnDeviationNumber = request.DeviationNumber;//上班与门店的偏差值
          delete request.DeviationNumber;
        }
        if(request.goonnumber){//进店与离店误差值
          request.a_GoOnDeviationNumber = request.goonnumber;//上班与门店的偏差值
          delete request.goonnumber;
        }
         //如果门店坐标不存在则下班必须拍照
         if(localStorage.getItem("clock"))
         {
           if(typeof(request["a_EndPhoto"])=="undefined"){
             webcontext.ResponseMessage.Success =false;
             webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
           }else if(request.a_EndPhoto.toString().trim() == ""){
             webcontext.ResponseMessage.Success =false;
             webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
           }
         }
             //表示定位成功但是偏差值大于设定的距离
        if(localStorage.getItem("clockOut")){
          // if(typeof(request["a_EndRemark"])=="undefined"){
          //   webcontext.ResponseMessage.Success =false;
          //   webcontext.ResponseMessage.ErrorMessage ="请填写备注说明";
          // }else if(request.a_EndRemark.toString().trim() == ""){
          //   webcontext.ResponseMessage.Success =false;
          //   webcontext.ResponseMessage.ErrorMessage ="请填写备注说明";
          // }else
          if(typeof(request["a_EndPhoto"])=="undefined"){
            webcontext.ResponseMessage.Success =false;
            webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
          }else if(request.a_EndPhoto.toString().trim() == ""){
            webcontext.ResponseMessage.Success =false;
            webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
          }

        }
        delete request.DeviationNumber;
        delete request.goonnumber;
        const info:any = localStorage.getItem("pginfo");
        const anyinfo = JSON.parse(info)||{};
        if(!anyinfo["a_ID"]){
          webcontext.ResponseMessage.Success =false;
          webcontext.ResponseMessage.ErrorMessage ="数据有误,请重新登录";
        }
        request["a_id"]= anyinfo["a_ID"];//排版ID
        request["a_SNEndDate"] = anyinfo["a_SNEndDate"];
        // let datepie:DatePipe =new DatePipe("en-US");
        // let datetime = datepie.transform(new Date(),"yyyy-MM-dd HH:mm:ss");//上班打卡时间
        //     request["a_EndDate"] = datetime;//上班打卡时间
        //     localStorage.setItem("enddate",datetime);
        //     //计算是否早退
        //     const info:any = localStorage.getItem("pginfo");
        //     const anyinfo = JSON.parse(info)||{};
        //     const workState:number = anyinfo["a_WorkState"];
        //         request["a_id"]=  anyinfo["a_ID"];//排版ID;
        //        let oldDate = anyinfo["a_SNEndDate"];//下班日期
        //        var oDate1 = new Date(datetime.replace(/-/g,"/"));//下班日期
        //        var oDate2 = new Date(oldDate.replace(/-/g,"/"));//结束日期
        //        if(oDate1.getTime()>oDate2.getTime()){//打卡时间大于上班时间则为迟到
        //         if(workState==2){
        //           request["a_WorkState"]=4;//表示迟到早退
        //         }else{
        //           request["a_WorkState"]=3;//表示早退
        //         }
        //        }else{
        //         request["a_WorkState"]=5;//表示正常
        //        }
      webcontext.RequestBody = JSON.stringify(request);
      webcontext.SpecialParameter = "clockOut";
    }

    return webcontext;
  }
  public HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext):WebResponesContext {
    const that = this;
    if (webParameterContext.ConfigType.toLowerCase() == "form") {
      if (webContext.ResponseMessage.Success) {
        localStorage.removeItem("clock");
        localStorage.removeItem("clockOut");
        localStorage.setItem("pgondate","true");
        const EndDate = webContext.Status["EndDate"] || "";
        const info:any = localStorage.getItem("pginfo");
        const anyinfo = JSON.parse(info)||{};
              anyinfo["a_EndDate"]=EndDate;
              localStorage.setItem("pginfo",JSON.stringify(anyinfo));
              // localStorage.removeItem("enddate");
      }
    }
    return webContext
  }
  

}